// Функция для загрузки и установки количества оценок на основе cookie
function updateRatingsFromCookies() {
  const allCookies = document.cookie.split(';');

  document.querySelectorAll('[data-post-id]').forEach((postElement) => {
    const postId = postElement.dataset.postId;

    if (postId) {
      // Ищем cookie для текущего поста
      const cookie = allCookies.find((c) => c.trim().startsWith(`did_user_rated_${postId}=`));

      if (cookie) {
        const totalRatings = parseInt(cookie.split('=')[1], 10);
        const ratingSpans = postElement.querySelectorAll('.rating');

        if (ratingSpans) {
          ratingSpans.forEach((span) => {
            const match = span.textContent.match(/(\d+\.\d+)\sиз\s5\s\((\d+)\)/);

            if (match) {
              let ratingValue = parseFloat(match[1]);

              // Обновляем текст с количеством оценок
              span.textContent = `${ratingValue} из 5 (${totalRatings})`;
            }
          });
        }
      }
    }
  });
}

// Вызываем функцию обновления при загрузке страницы
updateRatingsFromCookies();

export { updateRatingsFromCookies };
